import ApiCall from "../../utils/apiCall";

const initialState = { submitting: false, emailSent: false, error: false };

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "sendInvite.submitting":
      return { ...state, submitting: true, error: false };
    case "sendInvite.success":
      return { ...state, submitting: false, emailSent: true };
    case "sendInvite.error":
      return { ...state, submitting: false, error: true };
    case "sendInvite.reset":
      return { ...state, submitting: false, error: false, emailSent: false };
    default:
      return state;
  }
}

// Actions
export function sendInviteEmail(emailAddresses) {
  return dispatch => {
    dispatch({ type: "sendInvite.submitting" });
    ApiCall.post(`/send_invite_email`, { email_addresses: emailAddresses })
      .then(response => {
        dispatch({
          type: "sendInvite.success",
          success: response.json
        });
      })
      .catch(error => {
        dispatch({
          type: "sendInvite.error",
          error: error.json
        });
      });
  };
}

export function resetInviteSent() {
  return dispatch => {
    dispatch({ type: "sendInvite.reset" });
  };
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/module/sendInviteEmail.js